// extracted by mini-css-extract-plugin
module.exports = {"inputFile":"MediaUpload_inputFile__2vAUl","text":"MediaUpload_text__1yhER","cursorPointer":"MediaUpload_cursorPointer__UR-um"};